import React from "react";
import { observer, inject } from "mobx-react";
import { TablePageHeader } from "../../../components/TablePageHeader";
import { Row, Col, Table, Button, Form, Card } from "react-bootstrap";
import { CustomerOrdersStore } from "../../../stores/CustomerOrdersStore";
import { STORE_CUSTOMER_ORDERS, STORE_REPORT2 } from "../../../constants";
import { formatDateToMask, formatMoney, formatShortDate } from "../../../common/Formatting";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import { MultiSelect } from "../../../common/UI/MultiSelect";
import { Report2Store } from "../../../stores";
import { NotificationLevel } from "../../../stores/NotificationStore";
import { BaseChart } from "./Charts/BaseChart";
import { wrapCheckbox } from "../../../common/FormChangeWrapper";
registerLocale('ru', ru)

interface IState {
    filterFormIsOpened: boolean;
    filteredStatuses: number[];
    dateFrom?: Date;
    dateTo?: Date;
    splitBy: "day" | "month"
}

interface GroupedReportData {
    key: string;
    label: string;
    saleSum: number;
    purchaseSum: number;
    ordersCount: number;
    positionsCount: number;
    margin: number;
}

@inject(STORE_CUSTOMER_ORDERS, STORE_REPORT2)
@observer
export class Report2Page extends React.Component<{}, IState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            filterFormIsOpened: false,
            filteredStatuses: [2],
            splitBy: "day"
        };
    }

    report2Store = (this.props as any)[STORE_REPORT2] as Report2Store;
    customerOrdersStore = (this.props as any)[STORE_CUSTOMER_ORDERS] as CustomerOrdersStore;


    loadData = () => {
        if (this.state.filteredStatuses == undefined || this.state.filteredStatuses.length <= 0)
            this.report2Store._rootStore.notificationStore.addNotification("Не указан статус!", NotificationLevel.error);
        else
            this.report2Store.loadData(this.state.filteredStatuses, this.state.dateFrom, this.state.dateTo);
    }

    componentDidMount() {
        const savedFilter = JSON.parse(localStorage.getItem("report2Filter") || "{}");
        if (savedFilter.dateFrom != null) {
            savedFilter.dateFrom = new Date(savedFilter.dateFrom);
        }
        if (savedFilter.dateTo != null) {
            savedFilter.dateTo = new Date(savedFilter.dateTo);
        }

        this.setState(Object.assign({}, this.state, savedFilter), () => {
            this.customerOrdersStore.loadManagers();
            this.customerOrdersStore.loadStatuses();
        });
    }


    private toggleFilter = () => {
        const previousState = this.state.filterFormIsOpened;
        this.setState({
            filterFormIsOpened: !previousState
        });
    }
    private clearFilter = () => {
        this.setState({
            // filteredManagerIds: [],
            filteredStatuses: [],
            // filteredSources: [],
            dateFrom: undefined,
            dateTo: undefined,
            splitBy: "day"
        });
        localStorage.removeItem("report2Filter");
    }

    private changeFilter = (name: string, value: any) => {

        (this as any).setState({
            [name]: value
        }, () => {
            this.saveFilterToLocalStorage();
        });
    }

    private saveFilterToLocalStorage = () => {

        localStorage.setItem("report2Filter", JSON.stringify({
            filteredStatuses: this.state.filteredStatuses,
            dateFrom: this.state.dateFrom,
            dateTo: this.state.dateTo,
            filterFormIsOpened: true,
            splitBy: this.state.splitBy
        }));
    }

    private onFormCheckboxChange = (fieldName: string, value: string, checked: boolean) => {
        this.setState({
            splitBy: value as "day" | "month"
        });
    }



    render() {
        const dataItems: GroupedReportData[] = [];
        const localize: any = ru.localize;
        switch (this.state.splitBy) {
            case "month":
                for (let d = new Date(this.state.dateFrom || new Date().addMonth(-1)); d <= (this.state.dateTo || new Date()); d.setMonth(d.getMonth() + 1)) {
                    dataItems.push({
                        key: formatDateToMask(d, "MM.yyyy"),
                        label: `${localize.month(d.getMonth(), { width: 'abbreviated' })}, ${d.getFullYear()}`,
                        saleSum: 0,
                        purchaseSum: 0,
                        ordersCount: 0,
                        positionsCount: 0,
                        margin: 0
                    })
                }
                break;
            case "day":
                for (let d = new Date(this.state.dateFrom || new Date().addMonth(-1)); d <= (this.state.dateTo || new Date()); d.setDate(d.getDate() + 1)) {
                    dataItems.push({
                        key: formatDateToMask(d, "dd.MM.yyyy"),
                        label: `${formatShortDate(d)}, ${localize.day(d.getDay(), { width: 'abbreviated' })}`,
                        saleSum: 0,
                        purchaseSum: 0,
                        ordersCount: 0,
                        positionsCount: 0,
                        margin: 0
                    })
                }
                break;
        }

        const totals: any = {
            saleSum: 0,
            purchaseSum: 0,
            ordersCount: 0,
            positionsCount: 0,
            margin: 0
        };

        this.report2Store.items.forEach(item => {
            const year = new Date(item.date).getFullYear();
            const month = new Date(item.date).getMonth();
            // let week = new Date(item.date).;
            const day = new Date(item.date).getDay();
            let key = "";
            let label = "";
            switch (this.state.splitBy) {
                case "month":
                    key = formatDateToMask(item.date, "MM.yyyy");
                    label = `${localize.month(month, { width: 'abbreviated' })}, ${year}`;
                    break;
                case "day":

                    key = formatDateToMask(item.date, "dd.MM.yyyy");
                    label = `${formatShortDate(item.date)}, ${localize.day(item.date.getDay, { width: 'abbreviated' })}`;
                    break;
            }
            const index = dataItems.findIndex(w => w.key == key);
            const sum = 0;
            const count = 0;
            if (index == -1) {
                dataItems.push({
                    key: key,
                    label: label,
                    saleSum: 0,
                    purchaseSum: 0,
                    ordersCount: 0,
                    positionsCount: 0,
                    margin: 0
                })
            }
            else {
                dataItems[index].purchaseSum += item.purchaseSum || 0;
                dataItems[index].saleSum += item.saleSum || 0;
                dataItems[index].ordersCount += item.ordersCount || 0;
                dataItems[index].positionsCount += item.positionsCount || 0;
                dataItems[index].margin += (item.saleSum || 0) - (item.purchaseSum || 0);
            }
            totals.purchaseSum += item.purchaseSum || 0;
            totals.saleSum += item.saleSum || 0;
            totals.ordersCount += item.ordersCount || 0;
            totals.positionsCount += item.positionsCount || 0;
            totals.margin += (item.saleSum || 0) - (item.purchaseSum || 0);
        });


        return [
            <TablePageHeader header="Отчет по продажам Абтеки" reload={this.loadData} key="1">
                <Form inline onSubmit={(e: any) => {
                    e.preventDefault();
                    this.loadData();
                }}>

                    <Button type="button" size="sm" variant="secondary" active={this.state.filterFormIsOpened} style={{ marginLeft: "15px" }} onClick={this.toggleFilter}>
                        Фильтр
                    </Button>
                </Form>

            </TablePageHeader>,
            this.state.filterFormIsOpened ?
                <Row key="filter">
                    <Col sm="12">
                        <Card bg="light" >
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col sm="2">
                                            <Button variant="primary" size="sm" onClick={this.loadData}>Показать</Button>
                                            <Button
                                                variant="secondary"
                                                size="sm" style={{ marginLeft: "20px" }}
                                                onClick={this.clearFilter}>
                                                Очистить
                                            </Button>


                                        </Col>
                                        <Col sm="2">
                                            <Form.Group controlId="filterForm.SelectStatus">
                                                <Form.Label>Статус</Form.Label>
                                                <MultiSelect
                                                    precheckedAll={false}
                                                    title="Статус"
                                                    data={this.customerOrdersStore.statuses.map(w => { return { Key: w.Key.toString(), Value: w.Value } })}
                                                    selectedItems={this.state.filteredStatuses.map(w => w.toString())}
                                                    onChange={(keys: string[]) => {
                                                        this.changeFilter("filteredStatuses", keys);
                                                    }}
                                                    width="100%"
                                                    size="sm"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm="4">
                                            <Form.Group controlId="filterForm.DateFrom">
                                                <Form.Label>Дата с</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        monthsShown={2}
                                                        openToDate={(new Date()).addMonth(-1)}
                                                        name="dateFrom"
                                                        autoComplete="off"
                                                        onChange={(date: Date | null) => {
                                                            this.changeFilter("dateFrom", date || undefined)
                                                        }}
                                                        selected={this.state.dateFrom}
                                                    />
                                                </div>
                                            </Form.Group>

                                        </Col>
                                        <Col sm="2"></Col>
                                    </Row>
                                    <Row>
                                        <Col sm="4">
                                            <Form.Group as={Row} controlId="formSource">

                                                <Col sm="12">
                                                    <Form.Check inline id="sourceCheckboxAbteka" onChange={wrapCheckbox(this.onFormCheckboxChange)} name="splitBy" label="Месяц" type="radio" value="month" checked={this.state.splitBy == "month"} />
                                                    <Form.Check inline id="sourceCheckboxAb61" onChange={wrapCheckbox(this.onFormCheckboxChange)} name="splitBy" label="День" type="radio" value="day" checked={this.state.splitBy == "day"} />
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                        <Col sm="4">
                                            <Form.Group controlId="filterForm.DateTo">
                                                <Form.Label>Дата по</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        maxDate={new Date()}

                                                        onChange={(date: Date | null) => {
                                                            if (date != undefined) {
                                                                date.setHours(23);
                                                                date.setMinutes(59);
                                                                date.setSeconds(59);
                                                            }
                                                            this.changeFilter("dateTo", date || undefined)
                                                        }}
                                                        selected={this.state.dateTo}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>

                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                        <br />
                    </Col>
                </Row> : [],
            <Row key={"table_2"}>
                <Col sm={12}>
                    <BaseChart
                        dateFrom={this.state.dateFrom || new Date().addMonth(-1)}
                        dateTo={this.state.dateTo || new Date()}
                        data={this.report2Store.items}
                        splitBy={this.state.splitBy} />
                </Col>
            </Row >,
            <Row key="table_3">
                <Col sm={12}>
                    <Table bordered className="table-xxs">
                        <thead>
                            <tr>
                                <th className="text-center">Дата</th>
                                <th className="text-center">Заказов за дату</th>
                                <th className="text-center">Позиций за дату</th>
                                <th className="text-center">Сумма продаж за дату</th>
                                <th className="text-center">Сумма закупок за дату</th>
                                <th className="text-center">Сумма маржи за дату</th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                dataItems.map((item, index) => {
                                    return [<tr key={index}>
                                        <td className="text-center">{item.label}</td>
                                        <td className="text-center">{item.ordersCount}</td>
                                        <td className="text-center">{item.positionsCount}</td>
                                        <td className="text-center">{formatMoney(item.saleSum)}</td>
                                        <td className="text-center">{formatMoney(item.purchaseSum)}</td>
                                        <td className="text-center">{formatMoney(item.saleSum - item.purchaseSum)}</td>
                                    </tr>]
                                })
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <th className="text-right">Итого:</th>
                                <th className="text-center">{totals.ordersCount}</th>
                                <th className="text-center">{totals.positionsCount}</th>
                                <th className="text-center">{formatMoney(totals.saleSum)}</th>
                                <th className="text-center">{formatMoney(totals.purchaseSum)}</th>
                                <th className="text-center">{formatMoney(totals.margin)}</th>
                            </tr>
                        </tfoot>
                    </Table>
                </Col>
            </Row >
        ]
    }
}